import type { DiscoverSignUpGetResponse } from "libs/apiClient"
import { ContentCell } from "./ContentCell";
import client from "libs/client";
import { useId } from "react";
import { SecurityCodesTable } from "./SecurityCodesTable";
import { translateDiscoverRole } from "./functions";
import { Link } from "react-router";

interface DiscoverSignUpDetailProps {
	signUpData: DiscoverSignUpGetResponse;
}

export function DiscoverSignUpDetail({ signUpData }: DiscoverSignUpDetailProps) {
	const contentProps = {
		id: signUpData.id,
		mutation: client.patchDiscoverSignUp.useMutation(),
		invalidationKey: 'discoverSignUpDetail',
	};

	const tempId1 = useId();
	const tempId2 = useId();

	const userProps = [
		{
			key: useId(),
			title: "First Name",
			type: "string",
			value: signUpData.firstName,
		},
		{
			key: useId(),
			title: "Middle Name",
			type: "string",
			value: signUpData.middleName,
		},
		{
			key: useId(),
			title: "Last Name",
			type: "string",
			value: signUpData.lastName,
		},
		...(signUpData.user ? [{
			key: tempId1,
			title: "User",
			type: "link",
			formatter: () => <Link to={`/discover/user/${signUpData.user?.id}`} className="button-link">{`${signUpData.user?.name} (${signUpData.user?.id})`}</Link>,
		}] : [{
			key: tempId2,
			type: "empty",
		}]),
		{
			key: useId(),
			title: "E-mail",
			type: "string",
			value: signUpData.email,
		},
		{
			key: useId(),
			title: "Phone Number",
			type: "string",
			value: signUpData.phoneNumber,
		},
		{
			key: useId(),
			title: "Birthday",
			type: "date",
			value: signUpData.birthday,
		},
		{
			key: useId(),
			title: "Club Name",
			type: "string",
			value: signUpData.clubName,
		},
		{
			key: useId(),
			title: "Country",
			type: "string",
			value: signUpData.country?.name,
		},
		{
			key: useId(),
			title: "Created at",
			type: "datetime",
			value: signUpData.createdAt,
		},
		{
			key: useId(),
			title: "Created at",
			type: "datetime",
			value: signUpData.verifiedAt,
		},
		{
			key: useId(),
			title: "Role",
			type: "string",
			value: translateDiscoverRole(signUpData.role),
		},
	];

    return (
        <>
			<div className="discover-card__title">Basic user data</div>
			<div className="discover-card">
				<div className="cell-grid">
					{userProps.map((props) => {
						return <ContentCell {...contentProps} {...props} />
					})}
				</div>
			</div>

			<div className="discover-card__title">Confirmation security codes</div>
			<div className="discover-card">
				<SecurityCodesTable securityCodes={signUpData?.securityCodes || []} />
			</div>
		</>
	)
}
